import { cn } from "../../lib/cn.js";

/**
 * Page-width container — 1280px max content width per PRD § 13.3.
 * Use it inside section wrappers that handle their own background color.
 */
export function Container({ as: As = "div", className, children, ...props }) {
  return (
    <As className={cn("mx-auto w-full max-w-content px-6 lg:px-8", className)} {...props}>
      {children}
    </As>
  );
}
